import { $ as e, A as t, C as n, F as r, S as i, U as a, _ as o, g as s, h as c, i as l, m as u, nt as d, ot as f, q as p, t as m, v as h, w as g } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as _, t as v } from "./i18n-lite-BcmwMblk.js";
import { n as y, r as b, t as x } from "./normalize-props-DNjMoRjC.js";
import { n as S, r as C, t as w } from "./Cross.ce-B3B4wiAB.js";
import { t as T } from "./Stepper.ce-C5_sKJn0.js";
import { t as E } from "./Button.ce-Dstoud2U.js";
import { t as D } from "./shadow-dom-9FbsLIC0.js";
import { t as O } from "./Popin.ce-aq5qU85Q.js";
import { t as k } from "./PixMailMessage.ce-CiBuIIar.js";
//#region src/webcomponents/proteger-mail-spam/locales/de-AT.json
var A = {}, j = {}, M = {}, N = {}, P = { "proteger-mail-spam": {
	feedback: {
		step1: {
			blockSender: "En choisissant de bloquer l’expéditeur, vous ne recevrez plus de message de cet expéditeur.",
			delete: "Supprimer ce message ne vous empêche pas d’en recevoir d’autres de cet expéditeur. Sélectionnez une autre action de l’interface pour vous protéger de cet expéditeur.",
			forward: "Transférer ce message expose quelqu’un d’autre à l’arnaque, et ne vous empêche pas de recevoir d’autres mails de cet expéditeur. Sélectionnez une autre action de l’interface pour vous protéger de cet expéditeur.",
			reply: "Répondre confirme votre adresse mail et peut encourager l’escroc. Sélectionnez une autre action de l’interface pour vous protéger de cet expéditeur."
		},
		step2: {
			blockSender: "En choisissant de bloquer l’expéditeur, vous vous protégez de cet escroc mais vous ne protégez pas les autres.  Sélectionnez une autre action de l’interface pour protéger tous les utilisateurs.",
			delete: "Supprimer ce message ne vous permet ni de vous protéger, ni de protéger les autres de cet escroc.  Sélectionnez une autre action de l’interface pour protéger tous les utilisateurs.",
			forward: "Transférer ce message expose quelqu’un d’autre à l’arnaque. Sélectionnez une autre action de l’interface pour protéger tous les utilisateurs.",
			reply: "Répondre valide votre adresse mail et ne vous permet ni de vous protéger, ni de protéger les autres de cet escroc.  Sélectionnez une autre action de l’interface pour protéger tous les utilisateurs.",
			reportSpam: " En signalant ce message, vous vous protégez et vous contribuez à la protection des autres, car cela améliore les filtres anti-spam de tous les utilisateurs."
		},
		titleKo: "Mauvais choix",
		titleOk: "Bonne décision"
	},
	mailRecipent: "À moi",
	nextStepButton: "Continuer",
	step: "Étape {{step}} sur {{totalStep}}",
	successPopin: {
		buttonLabel: "Suivant",
		content: "Dans le prochain exemple, l’interface dispose d'avantage de possibilités.",
		title: "Se protéger, mais protéger aussi les autres."
	}
} }, F = { "proteger-mail-spam": {
	step: "Étape {{step}} sur {{totalStep}}",
	mailRecipent: "À moi",
	nextStepButton: "Continuer",
	successPopin: {
		title: "Se protéger, mais protéger aussi les autres.",
		content: "Dans le prochain exemple, l’interface dispose d'avantage de possibilités.",
		buttonLabel: "Suivant"
	},
	feedback: {
		titleOk: "Bonne décision",
		titleKo: "Mauvais choix",
		step1: {
			reply: "Répondre confirme votre adresse mail et peut encourager l’escroc. Sélectionnez une autre action de l’interface pour vous protéger de cet expéditeur.",
			forward: "Transférer ce message expose quelqu’un d’autre à l’arnaque, et ne vous empêche pas de recevoir d’autres mails de cet expéditeur. Sélectionnez une autre action de l’interface pour vous protéger de cet expéditeur.",
			delete: "Supprimer ce message ne vous empêche pas d’en recevoir d’autres de cet expéditeur. Sélectionnez une autre action de l’interface pour vous protéger de cet expéditeur.",
			blockSender: "En choisissant de bloquer l’expéditeur, vous ne recevrez plus de message de cet expéditeur."
		},
		step2: {
			reply: "Répondre valide votre adresse mail et ne vous permet ni de vous protéger, ni de protéger les autres de cet escroc.  Sélectionnez une autre action de l’interface pour protéger tous les utilisateurs.",
			forward: "Transférer ce message expose quelqu’un d’autre à l’arnaque. Sélectionnez une autre action de l’interface pour protéger tous les utilisateurs.",
			delete: "Supprimer ce message ne vous permet ni de vous protéger, ni de protéger les autres de cet escroc.  Sélectionnez une autre action de l’interface pour protéger tous les utilisateurs.",
			blockSender: "En choisissant de bloquer l’expéditeur, vous vous protégez de cet escroc mais vous ne protégez pas les autres.  Sélectionnez une autre action de l’interface pour protéger tous les utilisateurs.",
			reportSpam: " En signalant ce message, vous vous protégez et vous contribuez à la protection des autres, car cela améliore les filtres anti-spam de tous les utilisateurs."
		}
	}
} }, I = {}, L = {}, R = {
	ref: "container",
	class: "main-container",
	tabindex: "-1"
}, z = ["aria-level"], B = { class: "header__description" }, V = /*#__PURE__*/ m(/* @__PURE__ */ g({
	__name: "ProtegerMailSpam.ce",
	props: {
		titleLevel: {
			default: 2,
			type: Number
		},
		steps: { type: Array }
	},
	setup(l, { expose: m }) {
		let { t: g } = _();
		D();
		let v = e(0), y = e(""), b = e(!1), x = a("continue-button"), A = a("container"), j = u(() => l.steps.at(v.value)), M = u(() => j.value.goodAction === y.value), N = u(() => v.value === l.steps.length - 1), P = u(() => y.value ? g(`proteger-mail-spam.feedback.step${v.value + 1}.${y.value}`) : ""), F = u(() => M.value ? g("proteger-mail-spam.feedback.titleOk") : g("proteger-mail-spam.feedback.titleKo")), I = u(() => M.value ? {
			return: "disabled",
			reply: "disabled",
			forward: "disabled",
			menu: "disabled"
		} : j.value.actions);
		function L() {
			y.value = "", v.value = 0, b.value = !1;
		}
		async function V(e) {
			y.value = e, await t(), M.value && !N.value && x.value?.buttonElement.focus();
		}
		async function H() {
			v.value += 1, y.value = "", await t(), A.value.focus();
		}
		async function U() {
			await H(), b.value = !1;
		}
		return m({ reset: L }), (e, t) => (r(), h("div", R, [c("section", null, [
			c("div", null, [c("div", {
				role: "heading",
				"aria-level": l.titleLevel,
				class: "header__title"
			}, f(j.value.title), 9, z), c("p", B, f(j.value.description), 1)]),
			n(T, {
				step: v.value,
				"steps-count": l.steps.length
			}, null, 8, ["step", "steps-count"]),
			n(k, {
				actions: I.value,
				mail: j.value.mail,
				onAction: V
			}, null, 8, ["actions", "mail"]),
			n(C, { "display-feedback": !!y.value }, {
				icon: p(() => [M.value ? (r(), s(S, { key: 0 })) : (r(), s(w, { key: 1 }))]),
				title: p(() => [i(f(F.value), 1)]),
				content: p(() => [i(f(P.value), 1)]),
				_: 1
			}, 8, ["display-feedback"]),
			M.value && !N.value ? (r(), s(E, {
				key: 0,
				ref: "continue-button",
				class: "next-button",
				onClick: t[0] ||= (e) => b.value = !0
			}, {
				default: p(() => [i(f(d(g)("proteger-mail-spam.nextStepButton")), 1)]),
				_: 1
			}, 512)) : o("", !0)
		]), n(O, {
			content: d(g)("proteger-mail-spam.successPopin.content"),
			title: d(g)("proteger-mail-spam.successPopin.title"),
			show: b.value,
			"text-button": d(g)("proteger-mail-spam.successPopin.buttonLabel"),
			onPrimaryAction: U
		}, null, 8, [
			"content",
			"title",
			"show",
			"text-button"
		])], 512));
	}
}), [["styles", ["html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video,dialog{font-size:100%;font:inherit;vertical-align:baseline;border:0;margin:0;padding:0}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}table{border-collapse:collapse;border-spacing:0}.sr-only{clip-path:inset(50%);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}*{font-family:Roboto,Nunito,sans-serif}.main-container{position:relative}.main-container section{color:#122647;flex-direction:column;align-items:center;padding:.5rem;display:flex}.main-container section>:not(:first-child){margin-top:1.5rem}.main-container .header{text-align:center;font-style:normal}.main-container .header__title{text-align:center;margin-bottom:.25rem;font-family:Nunito,sans-serif;font-size:1.25rem;font-weight:700;line-height:28px}.main-container .header__description{text-align:center;font-family:Roboto,sans-serif;font-size:.875rem;line-height:20px}.main-container .next-button{font-size:.875rem;font-weight:700;line-height:24px}"]]]);
//#endregion
//#region src/webcomponents/proteger-mail-spam/proteger-mail-spam.ce.js
v.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": A,
	"./locales/en.json": j,
	"./locales/es-419.json": M,
	"./locales/es.json": N,
	"./locales/fr-BE.json": P,
	"./locales/fr.json": F,
	"./locales/it.json": I,
	"./locales/nl.json": L
}));
var H = l(V, { configureApp(e) {
	v.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(v);
} });
H.prototype.normalizeProps = (e) => {
	let t = e.steps.map((e) => {
		let t = {
			...e,
			actions: y({
				...e.actions,
				menuActions: y(e.actions?.menuActions)
			})
		};
		return t.mail.sender.avatarColor = b(t.mail.sender.avatarColor), t;
	});
	return {
		titleLevel: x(e.titleLevel),
		steps: t
	};
}, window.customElements.define("proteger-mail-spam", H);
//#endregion
